import { ThemeProvider, createTheme } from '@mui/material';
import { BrowserRouter as Router } from 'react-router-dom';
import { useSelector } from 'react-redux';
import App from './App';
import type { RootState } from './store/store';
import { BRAND_PRIMARY_DARK, BRAND_PRIMARY_LIGHT, DARKMODE_SPINNER_COLOR } from './utils/uiColors';

const RoutesAndTheme = () => {
  const lightThemeOrDarkTheme = useSelector((state: RootState) => state.themeSlice.theme);

  // Create a function to generate the theme based on the Redux state
  const generateTheme = (mode: 'light' | 'dark') => createTheme({
    palette: {
      mode: mode === "light" ? 'light' : 'dark',
      primary: {
        main: mode === "dark" ? BRAND_PRIMARY_DARK : BRAND_PRIMARY_LIGHT,
      },
      success: {
        main: '#219653',
      }
    },
    typography: {
      fontFamily: '"Segoe UI", "Helvetica Neue", Arial, sans-serif',
      fontWeightLight: 400,
      fontWeightRegular: 500,
      fontWeightMedium: 600,
      fontWeightBold: 700,
    },
    components: {
      MuiCircularProgress: {
        styleOverrides: {
          root: mode === "dark"
            ? {
                color: DARKMODE_SPINNER_COLOR,
              }
            : {},
        },
      },
    }
  });

  const theme = generateTheme(lightThemeOrDarkTheme);

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <App />
      </Router>
    </ThemeProvider>
  );
};

export default RoutesAndTheme; 
